import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import UIIllustration from 'UIComponents/image/UIIllustration';
const SUPPORT_LINK_BUTTON_WIDTH = 184;
const SUPPORT_LINK_IMAGE_HEIGHT = 72; // styles from https://git.hubteam.com/HubSpot/UIComponents/blob/master/UIComponents/static-3.2201/js//button/UISelectableButton.js

const Title = styled.span.withConfig({
  displayName: "SupportLinkBox__Title",
  componentId: "sc-1ugh4jn-0"
})(["width:100%;display:block;white-space:normal;margin-bottom:16px;margin-top:16px;"]);
const StyledSupportLinkButton = styled(props => {
  const {
    Button = UIButton,
    buttonProps = {}
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["Button", "buttonProps"]);

  return /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {}, buttonProps));
}).withConfig({
  displayName: "SupportLinkBox__StyledSupportLinkButton",
  componentId: "sc-1ugh4jn-1"
})(["display:flex;align-items:stretch;margin-left:12px;margin-top:12px;width:", "px;text-align:center !important;border-radius:3px;border:1px solid #7fd1de !important;user-select:none;cursor:pointer;transition:all 150ms ease-out;font-weight:600;font-size:16px;flex-direction:column;justify-content:center;min-height:180px;&&:hover{text-decoration:none;box-shadow:0 0 0 1px rgba(0,163,189,0.3),0 0 12px 0 rgba(0,163,189,0.3);}"], SUPPORT_LINK_BUTTON_WIDTH);
export default function SupportLinkBox(_ref) {
  let {
    Button,
    buttonProps,
    children,
    href,
    illustrationName,
    onClick,
    textLabel
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["Button", "buttonProps", "children", "href", "illustrationName", "onClick", "textLabel"]);

  return /*#__PURE__*/_jsxs(StyledSupportLinkButton, Object.assign({}, rest, {
    Button: Button,
    buttonProps: buttonProps,
    className: "p-all-5",
    href: href,
    iconProps: {
      className: 'hidden'
    },
    external: true,
    onClick: onClick,
    use: "unstyled",
    children: [children || /*#__PURE__*/_jsx(UIIllustration, {
      className: "p-top-2",
      height: SUPPORT_LINK_IMAGE_HEIGHT,
      name: illustrationName
    }), /*#__PURE__*/_jsx(Title, {
      children: textLabel
    })]
  }));
}